import feathersClientUOA from "../plugins/feathers-client-uoa";
import { LogoService } from "./LogoService";
import { differenceInDays, format, addHours } from "date-fns";

export const Nurseform = {
  async PrintHealthForm(PassId, type) {
    var customerlogo = await LogoService.GetLogoBaseurl64(4);

    //Signature
    var qp = {};
    qp.p_id = PassId;
    qp.$eager =
      "[passenger,passenger.[user.[company],destairport,departairport,company]]";

    var resdata = await feathersClientUOA
      .service("mubadala-health-form-2")
      .find({ query: qp });
    if (resdata.total > 0) {
      var datahealth = resdata.data[0];
      let companyName = "";
      if (datahealth.passenger.user.company != null) {
        // companyName = "";
        companyName = datahealth.passenger.user.company.c_name;
      }

      //console.log("PrintHealthForm", JSON.stringify(resdata));
      var signImage = datahealth.mhf_pass_singnature;

      // console.log(xMarks);
      var pdfMake = require("../../public/js/pdfmake");
      var pdfFonts = require("../../public/js/vfs_fonts");
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew-Bold.ttf",
          italics: "THSarabunNew-Italic.ttf",
          bolditalics: "THSarabunNew-BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
        Fontello: {
          normal: "fontello.ttf",
          bold: "fontello.ttf",
          italics: "fontello.ttf",
          bolditalics: "fontello.ttf",
        },
      };
      var docDefinitionyComplianceDeclarationForm = {
        compress: false,
        pageMargins: [40, 70, 40, 30],
        images: {
          signatureImage: Nurseform.checkimgnull(signImage),
          signaturenurseImage: Nurseform.checkimgnull(datahealth.mhf_nurse_singature)
        },
        header: [
          {
            style: "tableExample",
            layout: "noBorders",
            table: {
              widths: ["*", "*"],
              body: [
                [
                  {
                    text: "Medicine Declaretion Form",
                    fontSize: 16,
                    bold: true,
                    margin: [40, 20, 0, 0],
                    font: "Roboto",
                    color: "#C2C2C2",
                  },
                  {
                    width: customerlogo.w * 1.8,
                    height: customerlogo.h * 1.8,
                    alignment: "right",
                    margin: [0, 20, 21, 0],
                    image: customerlogo.logo,
                  },
                ],
              ],
            },
          },
        ],
        content: [
          {
            style: "tableExample",
            table: {
              widths: [70, 125, 40, 115, 20, 90],
              body: [
                [
                  {
                    text: "Name-Last name",
                    fontSize: 9,
                    bold: true,
                    font: "Roboto",
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      datahealth.passenger.user.u_firstname +
                      " " +
                      datahealth.passenger.user.u_lastname,
                    border: [false, false, false, true],
                    fontSize: 11,
                    // font: "Roboto",
                  },
                  {
                    text: "Company",
                    fontSize: 9,
                    bold: true,
                    font: "Roboto",
                    border: [false, false, false, false],
                  },
                  {
                    text: companyName,
                    border: [false, false, false, true],
                    fontSize: 11,
                    // font: "Roboto",
                  },
                  {
                    text: "Date",
                    fontSize: 9,
                    bold: true,
                    font: "Roboto",
                    border: [false, false, false, false],
                  },
                  {
                    text: Nurseform.checkdatenull(datahealth.mhf_pass_sign_date),
                    border: [false, false, false, true],
                    fontSize: 11,
                    // font: "Roboto",
                  },
                ],
                [
                  {
                    text: "ชื่อ-นามสกุล",
                    fontSize: 12,
                    border: [false, false, false, false],
                  },
                  { text: "", border: [false, false, false, false] },
                  {
                    text: "บริษัท",
                    fontSize: 12,
                    border: [false, false, false, false],
                  },
                  { text: "", border: [false, false, false, false] },
                  {
                    text: "วันที่",
                    fontSize: 12,
                    border: [false, false, false, false],
                  },
                  { text: "", border: [false, false, false, false] },
                ],
              ],
            },
          },
          {
            text: "Declaration of Medical History and Medication Used Form (Recorded by Passengers)",
            fontSize: 10,
            alignment: "center",
            bold: true,
            margin: [0, 10, 0, 0],
            font: "Roboto",
          },
          {
            text: "แบบแจ้งประวัติการเจ็บป่วยและยาที่แพทย์สั่ง (บันทึกโดยผู้โดยสาร)",
            fontSize: 12,
            alignment: "center",
          },
          {
            style: "tableExample",
            margin: [30, 0, 0, 0],
            table: {
              widths: [230, 25, 25, 45, 50, 50],
              body: [
                [
                  {
                    text: [
                      "\n",
                      {
                        text: "Medical History\n",
                        fontSize: 10,
                        alignment: "center",
                        bold: true,
                        font: "Roboto",
                      },
                      {
                        text: "ประวัติการเจ็บป่วย",
                        fontSize: 12,
                        alignment: "center",
                      },
                    ],
                    rowSpan: 2,
                  },
                  {
                    text: [
                      "\n",
                      {
                        text: "No\n",
                        fontSize: 10,
                        alignment: "center",
                        bold: true,
                        font: "Roboto",
                      },
                      {
                        text: "ไม่เป็น",
                        fontSize: 12,
                        alignment: "center",
                      },
                    ],
                    rowSpan: 2,
                  },
                  {
                    text: [
                      "\n",
                      {
                        text: "Yes\n",
                        fontSize: 10,
                        alignment: "center",
                        bold: true,
                        font: "Roboto",
                      },
                      {
                        text: "เป็น",
                        fontSize: 12,
                        alignment: "center",
                      },
                    ],
                    rowSpan: 2,
                  },
                  {
                    text: [
                      {
                        text: "Bring Medicine with you?\n",
                        fontSize: 10,
                        alignment: "center",
                        bold: true,
                        font: "Roboto",
                      },
                      {
                        text: "นำยามาด้วยหรือไม่",
                        fontSize: 12,
                        alignment: "center",
                      },
                    ],
                    colSpan: 2,
                  },
                  "5",
                  {
                    text: [
                      "\n",
                      {
                        text: "Name of Medicine\n",
                        fontSize: 10,
                        alignment: "center",
                        bold: true,
                        font: "Roboto",
                      },
                      {
                        text: "ชื่อยา",
                        fontSize: 12,
                        alignment: "center",
                      },
                    ],
                    rowSpan: 2,
                  },
                ],
                [
                  "",
                  "",
                  "",
                  {
                    text: [
                      {
                        text: "No\n",
                        fontSize: 10,
                        alignment: "center",
                        bold: true,
                        font: "Roboto",
                      },
                      {
                        text: "ไม่ได้นำมา",
                        fontSize: 12,
                        alignment: "center",
                      },
                    ],
                  },
                  {
                    text: [
                      {
                        text: "Yes\n",
                        fontSize: 10,
                        alignment: "center",
                        bold: true,
                        font: "Roboto",
                      },
                      {
                        text: "นำมาด้วย",
                        fontSize: 12,
                        alignment: "center",
                      },
                    ],
                  },
                  "",
                ],
                [
                  {
                    layout: "noBorders",
                    margin: [0, 0, 0, 0],
                    table: {
                      widths: [10, 205],
                      body: [
                        [
                          {
                            text: "1.",
                            fontSize: 10,
                            alignment: "center",
                            bold: true,
                            font: "Roboto",
                          },
                          {
                            text: [
                              {
                                text: "Circulation (E.g. Hypertension) \n",
                                fontSize: 10,
                                bold: true,
                                font: "Roboto",
                              },
                              {
                                text: "ระบบการไหลเวียนโลหิต (เช่น ความดันโลหิตสูง)",
                                fontSize: 12,
                              },
                            ],
                          },
                        ],
                      ],
                    },
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_medical_history1),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_medical_history1),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_bring_medicine1),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_bring_medicine1),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: datahealth.mhf_medicine_name1,
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    //font: "Roboto", หรือใส่เป็น => THSarabunNew
                    margin: [0, 10, 0, 0],
                  },
                ],
                [
                  {
                    layout: "noBorders",
                    margin: [0, 0, 0, 0],
                    table: {
                      widths: [10, 205],
                      body: [
                        [
                          {
                            text: "2.",
                            fontSize: 10,
                            alignment: "center",
                            bold: true,
                            font: "Roboto",
                          },
                          {
                            text: [
                              {
                                text: "Endocrine (E.g. Diabetes, Thyroid)\n",
                                fontSize: 10,
                                bold: true,
                                font: "Roboto",
                              },
                              {
                                text: "ระบบต่อมไร้ท่อ (เช่น - เบาหวาน/เบาจืด ไทรอยด์)",
                                fontSize: 12,
                              },
                            ],
                          },
                        ],
                      ],
                    },
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_medical_history2),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_medical_history2),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_bring_medicine2),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_bring_medicine2),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: datahealth.mhf_medicine_name2,
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    //font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                ],
                [
                  {
                    layout: "noBorders",
                    margin: [0, 0, 0, 0],
                    table: {
                      widths: [10, 205],
                      body: [
                        [
                          {
                            text: "3.",
                            fontSize: 10,
                            alignment: "center",
                            bold: true,
                            font: "Roboto",
                          },
                          {
                            text: [
                              {
                                text: "Neurological/Psychiatric (E.g. depression, epilepsy, seizure, dizziness, fainting, nervousness, anxiety, stroke)\n",
                                fontSize: 10,
                                bold: true,
                                font: "Roboto",
                              },
                              {
                                text: "ระบบประสาทและสมอง (เช่น. อาการซึมเศร้า ชักเกร็ง ลมบ้าหมู วิงเวียนศรีษะ วูบหรือหมดสติ ความผิดปกติของเส้นประสาท ภาวะเครียด ความผิดปกติของเส้นเลือดในสมอง)",
                                fontSize: 12,
                                lineHeight: 0.8,
                              },
                            ],
                          },
                        ],
                      ],
                    },
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_medical_history3),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_medical_history3),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_bring_medicine3),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_bring_medicine3),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: datahealth.mhf_medicine_name3,
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    //font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                ],
                [
                  {
                    layout: "noBorders",
                    margin: [0, 0, 0, 0],
                    table: {
                      widths: [10, 205],
                      body: [
                        [
                          {
                            text: "4.",
                            fontSize: 10,
                            alignment: "center",
                            bold: true,
                            font: "Roboto",
                          },
                          {
                            text: [
                              {
                                text: "Neurological/Psychiatric (E.g. depression, epilepsy, seizure, dizziness, fainting, nervousness, anxiety, stroke)\n",
                                fontSize: 10,
                                bold: true,
                                font: "Roboto",
                              },
                              {
                                text: "ระบบหัวใจและหลอดเลือด (เช่น. อาการเจ็บหน้าอก หัวใจวาย หัวใจเต้นผิดจังหวะ หัวใจพิการแต่กำเนิด การผ่าตัดหัวใจ ความผิดปกติของลิ้นหัวใจ ใส่เครื่องกระตุ้นการเต้นของหัวใจ)",
                                fontSize: 12,
                                lineHeight: 0.8,
                              },
                            ],
                          },
                        ],
                      ],
                    },
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_medical_history4),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_medical_history4),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_bring_medicine4),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_bring_medicine4),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: datahealth.mhf_medicine_name4,
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    //font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                ],
                [
                  {
                    layout: "noBorders",
                    margin: [0, 0, 0, 0],
                    table: {
                      widths: [10, 205],
                      body: [
                        [
                          {
                            text: "5.",
                            fontSize: 10,
                            alignment: "center",
                            bold: true,
                            font: "Roboto",
                          },
                          {
                            text: [
                              {
                                text: "Any other condition not listed above\n",
                                fontSize: 10,
                                bold: true,
                                font: "Roboto",
                              },
                              {
                                text: "ประวัติการเจ็บป่วย หรือความผิดปกติอื่นๆ โปรดระบุ",
                                fontSize: 12,
                              },
                            ],
                          },
                        ],
                      ],
                    },
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_medical_history5),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_medical_history5),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_bring_medicine5),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_bring_medicine5),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: datahealth.mhf_medicine_name5,
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    //font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                ],
                [
                  {
                    layout: "noBorders",
                    margin: [0, 0, 0, 0],
                    table: {
                      widths: [10, 205],
                      body: [
                        [
                          {
                            text: "6.",
                            fontSize: 10,
                            alignment: "center",
                            bold: true,
                            font: "Roboto",
                          },
                          {
                            text: [
                              {
                                text: "For Female only are you currently pregnant or suspecting of pregnant? \n",
                                fontSize: 10,
                                bold: true,
                                font: "Roboto",
                              },
                              {
                                text: "สำหรับสุภาพสตรี ขณะนี้คุณกำลังตั้งครรภ์ หรือสงสัยว่ากำลังตั้งครรภ์หรือไม่?",
                                fontSize: 12,
                                lineHeight: 0.8,
                              },
                            ],
                          },
                        ],
                      ],
                    },
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_medical_history6),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_medical_history6),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.isfalsebool(datahealth.mhf_bring_medicine6),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: Nurseform.istruebool(datahealth.mhf_bring_medicine6),
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                  {
                    text: datahealth.mhf_medicine_name6,
                    fontSize: 10,
                    alignment: "center",
                    bold: true,
                    //font: "Roboto",
                    margin: [0, 10, 0, 0],
                  },
                ],
              ],
            },
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
          },
          {
            text: "Declaration and Consent for release of information; I hereby certify that my answers to the questions are complete, accurate and no information has been withheld. I understand that if this is later shown not to be the case it may result in cancellation of an offshore trip, the offer of employment being withdrawn or reconsideration of my suitability to continue with my employment. ",
            fontSize: 8,
            bold: true,
            font: "Roboto",
            margin: [30, 10, 0, 0],
          },
          {
            text: "คำแถลงและยินยอมเปิดเผยข้อมูล; ข้าพเจ้ายอมรับว่าคำตอบที่ให้ไว้ถูกต้องสมบูรณ์ และเข้าใจว่าถ้าไม่เป็นจริงอาจมีผลต่อการปฎิเสธการเดินทาง และอาจมีผลต่อการจ้างงานของข้าพเจ้า",
            fontSize: 10,
            margin: [30, 8, 0, 0],
          },
          {
            text: "I agree to give consent to disclose the result of this questionnaire information to Mubadala Energy (Thailand) Ltd. ",
            fontSize: 8,
            bold: true,
            font: "Roboto",
            margin: [30, 10, 0, 0],
          },
          {
            text: "ข้าพเจ้ายินดีให้ความยินยอมเปิดเผยช้อมูลนี้แก่ บริษัท มูบาดาลา เอนเนอร์ยี่ (ประเทศไทย) จำกัด",
            fontSize: 10,
            margin: [30, 8, 0, 0],
          },
          {
            margin: [30, 0, 0, 0],
            table: {
              widths: [100, 5, 190, 5, 40, 85],
              body: [
                [
                  {
                    text: "Signed by Passenger",
                    fontSize: 8,
                    bold: true,
                    font: "Roboto",
                    border: [false, false, false, false],
                    margin: [0, 20, 0, 0],
                  },
                  {
                    image: "signatureImage",
                    width: 80,
                    height: 20,
                    alignment: "center",
                    colSpan: 3,
                    border: [false, false, false, true],
                  },
                  "",
                  "",
                  {
                    text: "Date",
                    fontSize: 8,
                    bold: true,
                    font: "Roboto",
                    alignment: "center",
                    border: [false, false, false, false],
                    margin: [0, 20, 0, 0],
                  },
                  {
                    text: Nurseform.checkdatenull(datahealth.mhf_pass_sign_date),
                    fontSize: 8,
                    font: "Roboto",
                    border: [false, false, false, true],
                    margin: [0, 20, 0, 0],
                  },
                ],
                [
                  {
                    text: "ลงนามโดยผู้โดยสาร",
                    fontSize: 10,
                    alignment: "center",
                    border: [false, false, false, false],
                  },
                  {
                    text: "(",
                    alignment: "right",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      datahealth.passenger.user.u_firstname +
                      " " +
                      datahealth.passenger.user.u_lastname,
                    fontSize: 10,
                    alignment: "center",
                    border: [false, false, false, false],
                  },
                  {
                    text: ")",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: "วันที่",
                    fontSize: 10,
                    alignment: "center",
                    border: [false, false, false, false],
                  },
                  {
                    text: "",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },

          {
            margin: [30, 0, 0, 0],
            table: {
              widths: [90, 155, 27, 50, 20, 20, 20],
              body: [
                [
                  {
                    text: "Reviewed by nurse ",
                    fontSize: 8,
                    bold: true,
                    font: "Roboto",
                    border: [false, false, false, false],
                    margin: [0, 10, 0, 0]
                  },
                  {
                    image: "signaturenurseImage",
                    width: 80,
                    height: 20,
                    alignment: "center",
                    border: [false, false, false, true],
                  },
                  {
                    text: "Advice:",
                    fontSize: 8,
                    bold: true,
                    font: "Roboto",
                    border: [false, false, false, false],
                    margin: [0, 10, 0, 0]
                  },
                  {
                    text: "Pass  YES",
                    fontSize: 8,
                    bold: true,
                    font: "Roboto",
                    alignment: "right",
                    border: [false, false, false, false],
                    margin: [0, 10, 0, 0]
                  },
                  {
                    text: Nurseform.ispassbool(datahealth.mhf_status),
                    fontSize: 8,
                    bold: true,
                    font: "Roboto",
                    alignment: "center",
                    border: [false, false, false, true],
                    margin: [0, 10, 0, 0]
                  },
                  {
                    text: "NO ",
                    fontSize: 8,
                    bold: true,
                    font: "Roboto",
                    alignment: "right",
                    border: [false, false, false, false],
                    margin: [0, 10, 0, 0]
                  },
                  {
                    text: Nurseform.isnotpassbool(datahealth.mhf_status),
                    fontSize: 8,
                    bold: true,
                    font: "Roboto",
                    alignment: "center",

                    border: [false, false, false, true],
                    margin: [0, 10, 0, 0]
                  },
                ],
                [
                  {
                    text: "ตรวจสอบโดยพยาบาล ",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text:
                      datahealth.mhf_nurse_sign_name,
                    fontSize: 10,
                    alignment: "center",
                    border: [false, false, false, false],
                  },
                  {
                    text: "คำแนะนำ",
                    fontSize: 10,
                    border: [false, false, false, false],
                  },
                  {
                    text: "ผ่าน ",
                    fontSize: 10,
                    alignment: "right",
                    border: [false, false, false, false],
                  },
                  {
                    text: "",
                    fontSize: 10,
                    bold: true,
                    font: "Roboto",
                    border: [false, false, false, false],
                  },
                  {
                    text: "  ไม่ผ่าน",
                    fontSize: 10,
                    colSpan: 2,
                    border: [false, false, false, false],
                  },
                  {
                    text: "",
                    fontSize: 10,
                    bold: true,
                    font: "Roboto",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
            layout: {
              paddingLeft: (i, node) => 0,
              paddingRight: (i, node) => 0,
            },
          },
        ],
        footer: function (currentPage, pageCount) {
          var footer = {
            text:
              "Medicine Declaration Form\nPage" +
              currentPage.toString() +
              " of " +
              pageCount,
            fontSize: 8,
            font: "Roboto",
            alignment: "center",
            color: "#C2C2C2",
          };

          return footer;
        },
        styles: {},
        defaultStyle: {
          font: "THSarabunNew",
        },
      };

      if (type == 1) {
        pdfMake.createPdf(docDefinitionyComplianceDeclarationForm).open({});
      } else if (type == 2) {
        pdfMake
          .createPdf(docDefinitionyComplianceDeclarationForm)
          .download(datahealth.passenger.user.u_firstname + " " + datahealth.passenger.user.u_lastname + "_" + PassId + "_Health Screening.pdf");
      }
      else if (type == 3) {
        const pdfDocGenerator = pdfMake.createPdf(docDefinitionyComplianceDeclarationForm);
        const wait = pdfData => new Promise(resolve => {
          pdfData.getBlob(blob => {
            resolve(blob);
          });
        });
        return await wait(pdfDocGenerator);
      }
    }

  },
  async PrintCovidForm(PassId, type) {
    var customerlogo = await LogoService.GetLogoBaseurl64(4);
    //
    //Signature
    var qp = {};
    qp.p_id = PassId;
    qp.$eager =
      "[passenger,passenger.[user.[company],destairport,departairport,baggage,company]]";
    var res = await feathersClientUOA
      .service("mubadala-covid-form-2")
      .find({ query: qp });
    if (res.total > 0) {
      var signImage = res.data[0].mcf_pass_signature;
      let companyName = "";
      if (res.data[0].passenger.user.company != null) {
        // companyName = "";
        companyName = res.data[0].passenger.user.company.c_name;
      }

      var pdfMake = require("../../public/js/pdfmake");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("../../public/js/vfs_fonts");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew-Bold.ttf",
          italics: "THSarabunNew-Italic.ttf",
          bolditalics: "THSarabunNew-BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
        Fontello: {
          normal: "fontello.ttf",
          bold: "fontello.ttf",
          italics: "fontello.ttf",
          bolditalics: "fontello.ttf",
        },
      };

      var docDefinitionyComplianceDeclarationForm = {
        pageMargins: [40, 70, 40, 30],
        images: {
          signatureImage: Nurseform.checkimgnull(signImage),
          signatureNurseImage: Nurseform.checkimgnull(res.data[0].mcf_nurse_signature)
        },
        header: [
          {
            style: "tableExample",
            layout: "noBorders",

            table: {
              widths: [400, "*"],
              body: [
                [
                  {
                    text: "SCREENING QUESTIONNAIRE COVID-19 and Monkeypox:",
                    fontSize: 10,
                    bold: true,
                    margin: [40, 40, 0, 0],
                    font: "Roboto",
                    color: "#C2C2C2",
                  },
                  {
                    width: customerlogo.w * 1.8,
                    height: customerlogo.h * 1.8,
                    alignment: "right",
                    margin: [0, 20, 21, 0],
                    image: customerlogo.logo,
                  },
                ],
              ],
            },
          },
        ],
        content: [
          {
            style: "en",
            text: "An outbreak of COVID-19 and Monkeypox requires early and effective detection of suspected cases to limit the risk of exposure to others. We are kindly requesting you to complete the following questions and to have your temperature checked by us.",
          },
          "\n",
          {
            style: "th",
            text: "การระบาดของโรคติดเชื้อโควิด19 และฝีดาษลิง จำเป็นต้องมีการตรวจหาผู้ต้องสงสัยในระยะแรกอย่างมีประสิทธิภาพ เพื่อจำกัดความเสี่ยงในการสัมผัสกับผู้อื่น เราขอให้คุณกรุณาตอบคำถามต่อไปนี้และให้เราตรวจสอบอุณหภูมิร่างกายของคุณ",
          },
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            table: {
              widths: [120, 372],
              body: [
                [
                  {
                    text: [
                      {
                        style: "en",
                        alignment: "center",
                        text: "First name - Last Name\n",
                      },
                      {
                        style: "th",
                        alignment: "center",
                        text: "ชื่อ - นามสกุล",
                      },
                    ],
                  },
                  {
                    style: "en",
                    text:
                      res.data[0].passenger.user.u_firstname +
                      " " +
                      res.data[0].passenger.user.u_lastname,
                    bold: false,
                    margin: [10, 7, 0, 0],
                  },
                ],
                [
                  {
                    text: [
                      {
                        style: "en",
                        alignment: "center",
                        text: "Company Name\n",
                      },
                      {
                        style: "th",
                        alignment: "center",
                        text: "ชื่อบริษัท",
                      },
                    ],
                  },
                  {
                    style: "en",
                    text: companyName,
                    bold: false,
                    margin: [10, 7, 0, 0],
                  },
                ],
                [
                  {
                    text: [
                      {
                        style: "en",
                        alignment: "center",
                        text: "Field Name\n",
                      },
                      {
                        style: "th",
                        alignment: "center",
                        text: "พื้นที่ที่ไปปฏิบัติงาน",
                      },
                    ],
                  },
                  {
                    style: "en",
                    text: res.data[0].passenger.destairport.ap_name,
                    bold: false,
                    margin: [10, 7, 0, 0],
                  },
                ],
              ],
            },
          },
          "\n",
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            layout: "noBorders",
            table: {
              widths: [10, 495],
              body: [
                [
                  {
                    style: "en",
                    text: "1",
                  },
                  {
                    style: "en",
                    text: "Do you currently have any of the following symptoms within the past 7 days? Yes/ No",
                  },
                ],
                [
                  {
                    style: "th",
                    text: "",
                  },
                  {
                    style: "th",
                    text: "คุณมีอาการดังต่อไปนี้หรือไม่ ในช่วง 7 วันที่ผ่านมา; มี / ไม่มี",
                  },
                ],
              ],
            },
          },
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            alignment: "center",
            table: {
              widths: [152, 38, 38, 152, 38, 38],
              body: [
                [
                  {
                    text: [
                      {
                        text: "Fever/Chills\n",
                        style: "en",
                      },
                      {
                        text: "มีไข้/อาการหนาวสั่น",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_a),
                  Nurseform.covidNo(res.data[0].mcf_1_a),
                  {
                    text: [
                      {
                        text: "Cough\n",
                        style: "en",
                      },
                      {
                        text: "อาการไอ",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_f),
                  Nurseform.covidNo(res.data[0].mcf_1_f),
                ],
                [
                  {
                    text: [
                      {
                        text: "Shortness of breath\n",
                        style: "en",
                      },
                      {
                        text: "หายใจถี่",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_b),
                  Nurseform.covidNo(res.data[0].mcf_1_b),
                  {
                    text: [
                      {
                        text: "Difficulty breathing\n",
                        style: "en",
                      },
                      {
                        text: "หายใจลำบาก",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_g),
                  Nurseform.covidNo(res.data[0].mcf_1_g),
                ],
                [
                  {
                    text: [
                      {
                        text: "Diarrhea\n",
                        style: "en",
                      },
                      {
                        text: "ภาวะท้องเสีย/อุจจาระร่วง",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_c),
                  Nurseform.covidNo(res.data[0].mcf_1_c),
                  {
                    text: [
                      {
                        text: "Anosmia (loss of smell)\n",
                        style: "en",
                      },
                      {
                        text: "สูญเสียการได้กลิ่น (จมูกไม่ได้กลิ่น)",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_h),
                  Nurseform.covidNo(res.data[0].mcf_1_h),

                ],
                [
                  {
                    text: [
                      {
                        text: "Ageusia (loss of taste)\n",
                        style: "en",
                      },
                      {
                        text: "สูญเสียการรับรสโดยสิ้นเชิง",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_d),
                  Nurseform.covidNo(res.data[0].mcf_1_d),
                  {
                    text: [
                      {
                        text: "Pink eye\n",
                        style: "en",
                      },
                      {
                        text: "ตาแดง",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_i),
                  Nurseform.covidNo(res.data[0].mcf_1_i),
                ],
                [
                  {
                    text: [
                      {
                        text: "Runny nose\n",
                        style: "en",
                      },
                      {
                        text: "น้ำมูกไหล",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_e),
                  Nurseform.covidNo(res.data[0].mcf_1_e),
                  {
                    text: [
                      {
                        text: "Skin rashes\n",
                        style: "en",
                      },
                      {
                        text: "มีผื่นขึ้น",
                        style: "th",
                      },
                    ],
                  },

                  Nurseform.covidYes(res.data[0].mcf_1_j),
                  Nurseform.covidNo(res.data[0].mcf_1_j),
                ],
              ],
            },
          },
          "\n",
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            layout: "noBorders",
            table: {
              widths: [12, 493],
              body: [
                [
                  {
                    style: "en",
                    text: "2",
                  },
                  {
                    style: "en",
                    text: "2.	Did you have close contact or spend time within 2 meters distance with a person who has been confirmed or under investigation of Covid-19 infection within the past 7 days?  Yes/ No\nIf yes, please provide more details about close contact person that tests positive for Covid-19;",
                  },
                ],
                [
                  {
                    style: "th",
                    text: "",
                  },
                  {
                    style: "th",
                    text: "คุณมีการติดต่อพูดคุยใกล้ชิดกับบุคคลที่มีการติดเชื้อโควิด19 หรือผู้ที่อยู่ในระหว่างการตรวจสอบหาภาวะติดเชื้อโควิด19 ในระยะเวลา 7 วันที่ผ่านมา หรือไม่; ใช่/ ไม่ใช่ \nหากใช่ โปรดระบุรายละเอียดการสัมผัสใกล้ชิดกับผู้ป่วยโควิด19;",
                  },
                ],
              ],
            },
          },
          Nurseform.covidQuestiontext(res.data[0].mcf_2, res.data[0].mcf_2_remark),
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            layout: "noBorders",
            table: {
              widths: [12, 493],
              body: [
                [
                  {
                    style: "en",
                    text: "3",
                  },
                  {
                    style: "en",
                    text: "Did you have history of COVID-19 disease? Yes/ No\nIf yes, please provide the details about the treatment;",
                  },
                ],
                [
                  {
                    style: "th",
                    text: "",
                  },
                  {
                    style: "th",
                    text: "คุณเคยมีประวัติป่วยเป็นโรคติดเชื้อโควิด19 หรือไม่; ใช่/ ไม่ใช่\nหากคุณเคยมีประวัติป่วยเป็นโรคติดเชื้อโควิด19 โปรดระบุรายละเอียดการรักษาตัว",
                  },
                ],
              ],
            },
          },
          Nurseform.covidQuestiontext(res.data[0].mcf_3, res.data[0].mcf_3_remark),
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            layout: "noBorders",
            table: {
              widths: [12, 493],
              body: [
                [
                  {
                    style: "en",
                    text: "4",
                  },
                  {
                    style: "en",
                    text: "Have you received the COVID-19 vaccine? Yes/ No",
                  },
                ],
                [
                  {
                    style: "th",
                    text: "",
                  },
                  {
                    style: "th",
                    text: "คุณได้รับวัคซีนไวรัสโคโรนา 2019 มาแล้วหรือไม่; ใช่/ ไม่ใช่",
                  },
                ],
              ],
            },
          },
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            table: {
              widths: [100, 20],
              body: [[
                {
                  border: [true, true, false, true],
                  text: [
                    {
                      style: "en",
                      text: "Completed 1 dose \n",
                    },
                    {
                      style: "th",
                      text: "ได้รับแล้ว 1 เข็ม",
                    },
                  ],
                },
                {
                  alignment: 'center',
                  border: [false, true, true, true],
                  text: [
                    {
                      style: "en",
                      fontSize: 21,
                      text: (res.data[0].mcf_4 == 1) ? "X" : "",
                    }
                  ],
                }],
              [
                {
                  border: [true, true, false, true],
                  text: [
                    {
                      style: "en",
                      text: "Completed 2 dose \n",
                    },
                    {
                      style: "th",
                      text: "ได้รับแล้ว 2 เข็ม",
                    },
                  ],
                },
                {
                  alignment: 'center',
                  border: [false, true, true, true],
                  text: [
                    {
                      style: "en",
                      fontSize: 21,
                      text: (res.data[0].mcf_4 == 2) ? "X" : "",
                    }
                  ],
                }], [
                {
                  border: [true, true, false, true],
                  text: [
                    {
                      style: "en",
                      text: "Completed 3 dose \n",
                    },
                    {
                      style: "th",
                      text: "ได้รับแล้ว 3 เข็ม",
                    },
                  ],
                },
                {
                  alignment: 'center',
                  border: [false, true, true, true],
                  text: [
                    {
                      style: "en",
                      fontSize: 21,
                      text: (res.data[0].mcf_4 == 3) ? "X" : "",
                    }
                  ],
                }], [
                {
                  border: [true, true, false, true],
                  text: [
                    {
                      style: "en",
                      text: "Completed 4 dose \n",
                    },
                    {
                      style: "th",
                      text: "ได้รับแล้ว 4 เข็ม",
                    },
                  ],
                },
                {
                  alignment: 'center',
                  border: [false, true, true, true],
                  text: [
                    {
                      style: "en",
                      fontSize: 21,
                      text: (res.data[0].mcf_4 == 4) ? "X" : "",
                    }
                  ],
                }], [
                {
                  border: [true, true, false, true],
                  text: [
                    {
                      style: "en",
                      text: "Completed >4 dose \n",
                    },
                    {
                      style: "th",
                      text: "ได้รับแล้วมากกว่า 4 เข็ม",
                    },
                  ],
                },
                {
                  alignment: 'center',
                  border: [false, true, true, true],
                  text: [
                    {
                      style: "en",
                      fontSize: 21,
                      text: (res.data[0].mcf_4 == 51) ? "X" : "",
                    }
                  ],
                }], [
                {
                  border: [true, true, false, true],
                  text: [
                    {
                      style: "en",
                      text: "None\n",
                    },
                    {
                      style: "th",
                      text: "ยังไม่ได้วัคซีน",
                    },
                  ],
                },
                {
                  alignment: 'center',
                  border: [false, true, true, true],
                  text: [
                    {
                      style: "en",
                      fontSize: 21,
                      text: (res.data[0].mcf_4 == 0) ? "X" : "",
                    }
                  ],
                }]]
            },
          },
          "\n",
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            layout: "noBorders",
            table: {
              widths: [12, 493],
              body: [
                [
                  {
                    style: "en",
                    text: "5",
                  },
                  {
                    style: "en",
                    text: "If yes, please details the name of vaccine, Dose (Booster dose) and receive date.",
                  },
                ],
                [
                  {
                    style: "th",
                    text: "",
                  },
                  {
                    style: "th",
                    text: "หากใช่ โปรดระบุยี่ห้อของวัคซีน และวันที่ได้รับ การฉีด (เฉพาะบูสเตอร์โดส)",
                  },
                ],
              ],
            },
          },
          // Nurseform.covidQuestiontext(res.data[0].mcf_5, (res.data[0].mcf_5_vaccine_name == null) ? "" : res.data[0].mcf_5_vaccine_name + ' ' + (res.data[0].mcf_5_vaccine_date == null) ? "" : res.data[0].mcf_5_vaccine_date),
          Nurseform.covidQuestiontext(res.data[0].mcf_5, ((res.data[0].mcf_5_vaccine_name == null) ? "" : res.data[0].mcf_5_vaccine_name) + ' ' + ((res.data[0].mcf_5_vaccine_date == null) ? "" : Nurseform.checkdatenull(res.data[0].mcf_5_vaccine_date))),
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            layout: "noBorders",
            table: {
              widths: [12, 493],
              body: [
                [
                  {
                    style: "en",
                    text: "6",
                  },
                  {
                    style: "en",
                    text: "Did you visit the place have outbreak of Monkeypox? (Central and West Africa, particularly the Democratic Republic of the Congo (DRC) and Nigeria)? Yes/ No\nIf yes, please provide details confirm place or area you visited;",
                  },
                ],
                [
                  {
                    style: "th",
                    text: "",
                  },
                  {
                    style: "th",
                    text: "คุณได้เดินทางไปยังพื้นที่ที่มีการแพร่ระบาดของโรคฝีดาษลิงหรือไม่ (ประเทศแถบแอฟริกา, คองโก หรือไนจีเรีย); ใช่/ ไม่ใช่\nหากใช่ หากใช่โปรดระบุสถานที่ที่ท่านเดินทางไป;",
                  },
                ],
              ],
            },
          },
          Nurseform.covidQuestiontext(res.data[0].mcf_6, res.data[0].mcf_6_remark),
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            layout: "noBorders",
            table: {
              widths: [12, 493],
              body: [
                [
                  {
                    style: "en",
                    text: "7",
                  },
                  {
                    style: "en",
                    text: "Do you currently have any of the following symptoms? Yes/ No",
                  },
                ],
                [
                  {
                    style: "th",
                    text: "",
                  },
                  {
                    style: "th",
                    text: "คุณมีอาการต่อไปนี้หรือไม่ เลือกทั้งหมดที่เกี่ยวข้อง: มี / ไม่มี",
                  },
                ],
              ],
            },
          },
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            alignment: "center",
            table: {
              widths: [152, 38, 38, 152, 38, 38],
              body: [
                [
                  {
                    text: [
                      {
                        text: "Headache\n",
                        style: "en",
                      },
                      {
                        text: "ปวดศรีษะ",
                        style: "th",
                      },
                    ],
                  },
                  Nurseform.covidYes(res.data[0].mcf_7_a),
                  Nurseform.covidNo(res.data[0].mcf_7_a),
                  {
                    text: [
                      {
                        text: "Back pain\n",
                        style: "en",
                      },
                      {
                        text: "ปวดหลัง",
                        style: "th",
                      },
                    ],
                  },
                  Nurseform.covidYes(res.data[0].mcf_7_e),
                  Nurseform.covidNo(res.data[0].mcf_7_e),
                ],
                [
                  {
                    text: [
                      {
                        text: "Fever (T > 38.5 C)\n",
                        style: "en",
                      },
                      {
                        text: "มีไข้ (T>38.5 C)",
                        style: "th",
                      },
                    ],
                  },
                  Nurseform.covidYes(res.data[0].mcf_7_b),
                  Nurseform.covidNo(res.data[0].mcf_7_b),
                  {
                    text: [
                      {
                        text: "Asthenia (profound weakness)\n",
                        style: "en",
                      },
                      {
                        text: "กล้ามเนื้ออ่อนแรง",
                        style: "th",
                      },
                    ],
                  },
                  Nurseform.covidYes(res.data[0].mcf_7_f),
                  Nurseform.covidNo(res.data[0].mcf_7_f),
                ],
                [
                  {
                    text: [
                      {
                        text: "Lymphadenopathy\n",
                        style: "en",
                      },
                      {
                        text: "ต่อมน้ำเหลืองโต",
                        style: "th",
                      },
                    ],
                  },
                  Nurseform.covidYes(res.data[0].mcf_7_c),
                  Nurseform.covidNo(res.data[0].mcf_7_c),
                  {
                    text: [
                      {
                        text: "Unexplained acute rash\n",
                        style: "en",
                      },
                      {
                        text: "ผื่นที่ไม่ทราบสาเหตุ",
                        style: "th",
                      },
                    ],
                  },
                  Nurseform.covidYes(res.data[0].mcf_7_g),
                  Nurseform.covidNo(res.data[0].mcf_7_g),
                ],
                [
                  {
                    text: [
                      {
                        text: "Myalgia (muscle and body aches)\n",
                        style: "en",
                      },
                      {
                        text: "ปวดเมื่อยกล้ามเนื้อ",
                        style: "th",
                      },
                    ],
                  },
                  Nurseform.covidYes(res.data[0].mcf_7_d),
                  Nurseform.covidNo(res.data[0].mcf_7_d),
                  {
                    text: [
                      {
                        text: "Other symptoms\n",
                        style: "en",
                      },
                      {
                        text: "อาการอื่นๆ",
                        style: "th",
                      },
                    ],
                  },
                  Nurseform.covidYes(res.data[0].mcf_7_h),
                  Nurseform.covidNo(res.data[0].mcf_7_h),
                ],

              ],
            },
          },
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            layout: "noBorders",
            table: {
              widths: [12, 493],
              body: [
                [
                  {
                    style: "en",
                    text: "8",
                  },
                  {
                    style: "en",
                    text: "Did you have close contact with a person who has been confirmed of Monkeypox? Yes/ No\nIf yes, please provide more details;",
                  },
                ],
                [
                  {
                    style: "th",
                    text: "",
                  },
                  {
                    style: "th",
                    text: "คุณมีการสัมผัสใกล้ชิดกับบุคคลที่มีการติดเชื้อโรคฝีดาษลิง หรือไม่; ใช่ / ไม่ใช่\nหากใช่ โปรดระบุรายละเอียดการสัมผัสใกล้ชิดกับผู้ติดเชื้อ",
                  },
                ],
              ],
            },
          },
          Nurseform.covidQuestiontext(res.data[0].mcf_8, res.data[0].mcf_8_remark),
          {
            table: {
              widths: ["*", "*"],
              body: [
                [
                  {
                    text: [
                      {
                        style: "en",
                        text: "Staff / Passenger name-last name & Signature:\n",
                      },
                      {
                        style: "th",
                        text: "ชื่อพนักงาน/ผู้โดยสาร (ตัวบรรจง) & ลายเซ็น:",
                      },
                    ],
                    border: [true, true, true, false],
                  },
                  {
                    text: [
                      {
                        style: "en",
                        text: "Date\n",
                      },
                      {
                        style: "th",
                        text: "วันที่  :",
                      },
                    ],
                    border: [true, true, true, false],
                  },
                ],
                [

                  {
                    image: "signatureImage",
                    alignment: "center",
                    width: 80,
                    height: 20,
                    border: [true, false, true, false],
                  },
                  { text: Nurseform.checkdatenull(res.data[0].mcf_pass_sign_date), border: [true, false, true, true], rowSpan: 2, alignment: "center", },
                ],
                [
                  {
                    text: res.data[0].passenger.user.u_firstname + ' ' + res.data[0].passenger.user.u_lastname,
                    style: 'en',
                    border: [true, false, true, true],
                    bold: false,
                    alignment: 'center'
                  }, "1"],
                [
                  {
                    text: [
                      {
                        style: "en",
                        text: "Nurse’s name-last name & Signature:\n",
                      },
                      {
                        style: "th",
                        text: "ชื่อพยาบาล (ตัวบรรจง):",
                      },
                    ],
                    border: [true, true, true, false],
                  },
                  {
                    text: [
                      {
                        style: "en",
                        text: "Date:\n",
                      },
                      {
                        style: "th",
                        text: "วันที่ :",
                      },
                    ],
                    border: [true, true, true, false],
                  },
                ],
                [
                  {
                    image: "signatureNurseImage",
                    alignment: "center",
                    width: 80,
                    height: 20,
                    border: [true, false, true, false],
                  },
                  { text: Nurseform.checkdatenull(res.data[0].mcf_nurse_sign_date), alignment: 'center', border: [true, false, true, true], rowSpan: 2 },
                ],
                [
                  {
                    text: res.data[0].mcf_nurse_sign_name,
                    // style: 'en',
                    border: [true, false, true, true],
                    bold: false,
                    alignment: 'center'
                  }, "1"],
              ],
            },
          },
          {
            style: "en",
            text: "Note: 	 I declare that the provided information is true, and authorized to Mubadala Energy (Thailand), for further investigation",
          },
          {
            style: "th",
            text: "หมายเหตุ: ข้าพเจ้าขอรับรองว่าข้อมูลที่รายงานข้างต้นเป็นความจริงทุกประการ และอนุญาตให้ใช้ข้อมูลเบื้องต้นกับ บริษัท มูบาดาลา เอนเนอร์ยี่ ประเทศไทย ในการพิจารณาลำดับถัดไป   ",
          },
          "\n",
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
            },
            layout: "noBorders",
            lineHeight: 0.5,
            table: {
              widths: [20, 495],
              body: [
                [
                  {
                    style: "en",
                    text: "-",
                    alignment: "right",
                  },
                  {
                    style: "en",
                    text: "Failing to report accurate details may be subjected to disciplinary action",
                    italics: true,
                  },
                ],
                [
                  {
                    style: "th",
                    text: "",
                  },
                  {
                    style: "th",
                    text: "หากแจ้งข้อมูลเป็นเท็จหรือไม่ครบถ้วน อาจมีความผิดทางวินัย",
                    italics: true,
                  },
                ],
              ],
            },
          },
        ],
        footer: function (currentPage, pageCount) {
          var footer = {
            text:
              "Screening Questionnaire COVID-19&Monkeypok \nPage" +
              currentPage.toString() +
              " of " +
              pageCount,
            fontSize: 8,
            font: "Roboto",
            alignment: "center",
            color: "#C2C2C2",
          };

          return footer;
        },
        styles: {
          th: {
            fontSize: 12,
            lineHeight: 0.8,
          },
          en: {
            fontSize: 9,
            bold: true,
            font: "Roboto",
          },
        },
        defaultStyle: {
          font: "THSarabunNew",
        },
      };

      if (type == 1) {
        pdfMake.createPdf(docDefinitionyComplianceDeclarationForm).open({});
      } else if (type == 2) {
        pdfMake
          .createPdf(docDefinitionyComplianceDeclarationForm)
          .download(res.data[0].passenger.user.u_firstname + ' ' + res.data[0].passenger.user.u_lastname + "_" + PassId + "_Covid Screening.pdf");
      }
      else if (type == 3) {
        const pdfDocGenerator = pdfMake.createPdf(docDefinitionyComplianceDeclarationForm);
        const wait = pdfData => new Promise(resolve => {
          pdfData.getBlob(blob => {
            resolve(blob);
          });
        });
        return await wait(pdfDocGenerator);
      }
    }
  },
  async PrintAlcoholForm(PassId, type) {
    var customerlogo = await LogoService.GetLogoBaseurl64(4);

    //Signature
    var qp = {};
    qp.p_id = PassId;
    qp.$eager =
      "[passenger,passenger.[user.[company],destairport,departairport,baggage,company],mubadala_alcohol_form_detail]";
    var resdata = await feathersClientUOA
      .service("mubadala-alcohol-form-2")
      .find({ query: qp });
    if (resdata.total > 0) {
      let companyName = "";
      if (resdata.data[0].passenger.user.company != null) {
        // companyName = "";
        companyName = resdata.data[0].passenger.user.company.c_name;
      }
      var drug_arr = [
        [
          {
            text: [
              {
                style: "en",
                text: "Drugs/Dosage\n",
              },
              {
                style: "th",
                text: "ยา/ขนาดที่ใช้",
              },
            ],
            alignment: "center",
            border: [false, false, false, false],
          },
          {
            text: " ",
            border: [false, false, false, false],
          },
          {
            text: [
              {
                style: "en",
                text: "Prescribed by, when\n",
              },
              {
                style: "th",
                text: "สั่งจ่ายโดย/เมื่อ",
              },
            ],
            alignment: "center",
            border: [false, false, false, false],
          },
        ],
      ];
      for (
        let index = 0;
        index < resdata.data[0].mubadala_alcohol_form_detail.length;
        index++
      ) {
        const element = [
          {
            text:
              resdata.data[0].mubadala_alcohol_form_detail[index]
                .mafd_drugs_name +
              "/" +
              resdata.data[0].mubadala_alcohol_form_detail[index].mafd_dosage +
              " " +
              resdata.data[0].mubadala_alcohol_form_detail[index].mafd_unit,
            border: [false, false, false, true],
            alignment: "center",
          },
          {
            text: " ",
            border: [false, false, false, false],
          },
          {
            text: resdata.data[0].mubadala_alcohol_form_detail[index]
              .mafd_prescribed_by + "/" + Nurseform.checkdatenull(resdata.data[0].mubadala_alcohol_form_detail[index].mafd_date),
            border: [false, false, false, true],
            alignment: "center",
          },
        ];
        drug_arr.push(element);
      }
      if (resdata.data[0].mubadala_alcohol_form_detail.length < 4) {
        for (
          let index = 0;
          index < 4 - resdata.data[0].mubadala_alcohol_form_detail.length;
          index++
        ) {
          const element = [
            {
              text: " ",
              border: [false, false, false, true],
            },
            {
              text: " ",
              border: [false, false, false, false],
            },
            {
              text: " ",
              border: [false, false, false, true],
            },
          ];
          drug_arr.push(element);
        }
      }

      var signImage = resdata.data[0].maf_pass_signature;

      var pdfMake = require("../../public/js/pdfmake");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("../../public/js/vfs_fonts");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew-Bold.ttf",
          italics: "THSarabunNew-Italic.ttf",
          bolditalics: "THSarabunNew-BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
        Fontello: {
          normal: "fontello.ttf",
          bold: "fontello.ttf",
          italics: "fontello.ttf",
          bolditalics: "fontello.ttf",
        },
      };
      var docDefinitionyComplianceDeclarationForm = {
        pageMargins: [60, 70, 60, 40],
        images: {
          signatureImage: Nurseform.checkimgnull(signImage),
          signaturenurseImage: Nurseform.checkimgnull(resdata.data[0].maf_nurse_signature)
        },
        header: [
          {
            style: "tableExample",
            layout: "noBorders",

            table: {
              widths: ["*", "*"],
              body: [
                [
                  {
                    text: " ",
                    fontSize: 16,
                    bold: true,
                    margin: [40, 20, 0, 0],
                    font: "Roboto",
                    color: "#C2C2C2",
                  },
                  {
                    width: customerlogo.w * 1.8,
                    height: customerlogo.h * 1.8,
                    alignment: "right",
                    margin: [0, 20, 21, 0],
                    image: customerlogo.logo,
                  },
                ],
              ],
            },
          },
        ],
        content: [
          {
            style: "en",
            fontSize: 12,
            alignment: "center",
            text: "Alcohol and Urine Controlled Drugs Test Consent Form\n(This consent form is used for Alcohol and Urine Drugs Test program only)",
          },
          {
            style: "th",
            fontSize: 14,
            alignment: "center",
            text: "แบบสำแดงความยินยอมตรวจแอลกอฮอล์และสารเสพติด\n(ใช้สำหรับการตรวจแอลกอฮอล์และสารเสพติดเท่านั้น)",
          },
          "\n",
          {
            style: "en",
            decoration: "underline",
            text: "Section I",
            fontSize: 11,
          },
          {
            style: "th",
            decoration: "underline",
            text: "ส่วนที่ 1",
          },
          "\n",
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
              paddingLeft: (i, node) => 0,
              paddingRight: (i, node) => 0,
            },
            table: {
              widths: [30, 165, 45, 230],
              body: [
                [
                  {
                    style: "en",
                    text: "Name:",
                    border: [false, false, false, false],
                  },
                  {
                    style: "en",
                    text:
                      resdata.data[0].passenger.user.u_firstname +
                      " " +
                      resdata.data[0].passenger.user.u_lastname,
                    border: [false, false, false, true],
                    bold: false,
                    fontSize: 8,
                  },
                  {
                    style: "en",
                    text: "Position:",
                    border: [false, false, false, false],
                  },
                  {
                    text: resdata.data[0].passenger.user.u_jobposition,
                    border: [false, false, false, true],
                    bold: false,
                    fontSize: 8,
                  },
                ],
                [
                  {
                    style: "th",
                    text: "ชื่อนามสกุล:",
                    border: [false, false, false, false],
                    colSpan: 2,
                  },
                  {
                    style: "en",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "ตำแหน่ง:",
                    border: [false, false, false, false],
                    colSpan: 2,
                  },
                  {
                    style: "en",
                    text: " ",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          "\n",
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
              paddingLeft: (i, node) => 0,
              paddingRight: (i, node) => 0,
            },
            table: {
              widths: [46, 100, 85, 110, 60, "*"],
              body: [
                [
                  {
                    style: "en",
                    text: "Company:",
                    border: [false, false, false, false],
                  },
                  {
                    //style: "en",
                    text: companyName,
                    border: [false, false, false, true],
                    bold: false,
                    fontSize: 11,
                  },
                  {
                    style: "en",
                    text: "Supervisor’s name:",
                    border: [false, false, false, false],
                  },
                  {
                    // style: "en",
                    text: " ",
                    border: [false, false, false, true],
                    fontSize: 11,
                  },
                  {
                    style: "en",
                    text: "Department: ",
                    border: [false, false, false, false],
                  },
                  {
                    // style: "en",
                    text: resdata.data[0].passenger.user.u_department,
                    border: [false, false, false, true],
                    bold: false,
                    fontSize: 11,
                  },
                ],

                [
                  {
                    style: "th",
                    text: "บริษัท:",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "ชื่อหัวหน้างาน:",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "แผนก: ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: " ",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          "\n",
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 5,
                x2: 477,
                y2: 5,
                lineWidth: 0.5,
              },
            ],
          },
          {
            layout: "noBorders",
            margin: [0, 10, 0, 0],
            table: {
              widths: [55, 15, 100, 15, "*"],
              body: [
                [
                  {
                    style: "en",
                    text: "Test:",
                  },
                  Nurseform.checkbox(resdata.data[0].maf_test, 1),
                  {
                    style: "en",
                    text: "Breath Alcohol",
                  },
                  Nurseform.checkbox(resdata.data[0].maf_test, 2),
                  {
                    style: "en",
                    text: "Urine Controlled Substance",
                  },
                ],
                [
                  {
                    style: "th",
                    text: "ชนิดการตรวจ",
                  },
                  "",
                  {
                    style: "th",
                    text: "แอลกอฮอล์ทางลมหายใจ",
                  },
                  "",
                  {
                    style: "th",
                    text: "สารเสพติดทางปัสสาวะ ",
                  },
                ],
              ],
            },
          },
          "\n",
          {
            table: {
              widths: [55, 15, 75, 15, 50, 15, 60, 15, 25, "*"],
              body: [
                [
                  {
                    style: "en",
                    text: "Reasons:",
                    border: [false, false, false, false],
                  },
                  Nurseform.checkbox(resdata.data[0].maf_reason, 1),
                  {
                    style: "en",
                    text: "Pre-employment",
                    border: [false, false, false, false],
                  },
                  Nurseform.checkbox(resdata.data[0].maf_reason, 2),
                  {
                    style: "en",
                    text: "With cause",
                    border: [false, false, false, false],
                  },
                  Nurseform.checkbox(resdata.data[0].maf_reason, 3),
                  {
                    style: "en",
                    text: "Random test",
                    border: [false, false, false, false],
                  },
                  Nurseform.checkbox(resdata.data[0].maf_reason, 4),
                  {
                    style: "en",
                    text: "Other",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: resdata.data[0].maf_reason_remark,
                    border: [false, false, false, true],
                  },
                ],
                [
                  {
                    style: "th",
                    text: "สาเหตุการตรวจ",
                    border: [false, false, false, false],
                    colSpan: 2,
                  },
                  {
                    style: "th",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "ก่อนเข้าทำงาน",
                    alignment: "center",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "มีสาเหตุ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "การสุ่มตรวจ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "อื่นๆ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: " ",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          {
            canvas: [
              {
                type: "line",
                x1: 0,
                y1: 5,
                x2: 477,
                y2: 5,
                lineWidth: 0.5,
              },
            ],
            margin: [0, 10, 0, 0],
          },
          "\n",
          {
            style: "en",
            decoration: "underline",
            text: "Section II",
            fontSize: 11,
          },
          {
            style: "th",
            decoration: "underline",
            text: "ส่วนที่ 2",
          },
          "\n",
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
              paddingLeft: (i, node) => 0,
              paddingRight: (i, node) => 0,
            },
            table: {
              widths: [35, "*"],
              body: [
                [
                  {
                    style: "en",
                    fontSize: 15,
                    alignment: "center",
                    text: Nurseform.istruebool(resdata.data[0].maf_consent_permiss),
                    border: [false, false, false, true],
                  },
                  {
                    style: "en",
                    margin: [0, 5, 0, 0],
                    text: "I, the undersigned give my permission for the company to conduct the test.",
                    border: [false, false, false, false],
                  },
                ],
                [
                  {
                    style: "en",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "ข้าพเจ้ายินยอมให้บริษัททำการตรวจครั้งนี้",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          "\n",
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
              paddingLeft: (i, node) => 0,
              paddingRight: (i, node) => 0,
            },
            table: {
              widths: [35, "*"],
              body: [
                [
                  {
                    style: "en",
                    fontSize: 15,
                    alignment: "center",
                    text: Nurseform.isfalsebool(resdata.data[0].maf_consent_permiss),
                    border: [false, false, false, true],
                  },
                  {
                    style: "en",
                    margin: [0, 5, 0, 0],
                    text: "I, the undersigned decline my permission for the company to conduct the test.",
                    border: [false, false, false, false],
                  },
                ],
                [
                  {
                    style: "en",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "ข้าพเจ้าไม่ยินยอมให้บริษัททำการตรวจครั้งนี้",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          "\n",
          {
            style: "en",
            text: "I understand that my declination may result in disciplinary action which includes",
            margin: [55, 0, 0, 0],
          },
          {
            style: "en",
            text: "termination of employment.",
            margin: [35, 0, 0, 0],
          },
          {
            style: "th",
            text: "ข้าพเจ้าเข้าใจและยอมรับว่าการปฎิเสธการตรวจอาจมีผลต่อการลงโทษและรวมถึงการสิ้นสุดการว่าจ้างโดยบริษัท",
          },
          "\n",
          {
            fontSize: 11,
            text: [
              {
                style: "en",
                decoration: "underline",
                text: "Section III",
              },
              {
                style: "en",
                text: "\tSelf – declaration of any medications or drugs used (within 14 days)",
              },
            ],
          },
          {
            text: [
              {
                style: "th",
                decoration: "underline",
                text: "ส่วนที่  3",
              },
              {
                style: "th",
                text: "\tการยินยอมแจ้งการใช้ยา หรือ สารเสพติดด้วยตนเอง (ภายใน 14 วัน)",
              },
            ],
          },
          "\n",
          ,
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
              paddingLeft: (i, node) => 0,
              paddingRight: (i, node) => 0,
            },
            table: {
              widths: [35, "*"],
              body: [
                [
                  {
                    style: "en",
                    fontSize: 15,
                    alignment: "center",
                    text: Nurseform.isfalsebool(resdata.data[0].maf_consent_drug),
                    border: [false, false, false, true],
                  },
                  {
                    style: "en",
                    margin: [0, 5, 0, 0],
                    text: "I, the undersigned declare that I do not use any medication or drugs",
                    border: [false, false, false, false],
                  },
                ],
                [
                  {
                    style: "en",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "ข้าพเจ้า ขอแจ้งว่า ไม่ได้ใช้ยา หริอสารเสพติดใดๆ ",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
          },
          "\n",
          ,
          {
            layout: {
              paddingTop: (i, node) => 0,
              paddingBottom: (i, node) => 0,
              paddingLeft: (i, node) => 0,
              paddingRight: (i, node) => 0,
            },
            table: {
              widths: [35, "*"],
              body: [
                [
                  {
                    style: "en",
                    fontSize: 15,
                    alignment: "center",
                    text: Nurseform.istruebool(resdata.data[0].maf_consent_drug),
                    border: [false, false, false, true],
                  },
                  {
                    style: "en",
                    margin: [0, 5, 0, 0],
                    text: "I, the undersigned declare that I use the medication or drugs as listed below",
                    border: [false, false, false, false],
                  },
                ],
                [
                  {
                    style: "en",
                    text: " ",
                    border: [false, false, false, false],
                  },
                  {
                    style: "th",
                    text: "ข้าพเจ้า ขอแจ้งว่า ใช้ยาหรือสารเสพติดดังต่อไปนี้",
                    border: [false, false, false, false],
                  },
                ],
              ],
            },
            pageBreak: "after",
          },
          {
            text: [
              {
                style: "en",
                decoration: "underline",
                text: "Section IV",
                fontSize: 11,
              },
              {
                style: "en",
                text: "  Drugs & Alcohol Policy Compliance Declaration",
                fontSize: 11,
              }
            ]
          },
          {
            text: [
              {
                style: "th",
                decoration: "underline",
                text: "ส่วนที่ 4",
              },
              {
                style: "th",
                text: "       แบบสำแดงยืนยันปฏิบัติตามนโยบายด้านสิ่งเสพติดและแอลกอฮอล์",
                bold: true
              }
            ]
          },
          {
            margin: [-20, 10, -20, 0],
            text: [
              {
                style: "th",
                text: "1) ท่านมีสารหรือสิ่งเสพติดต้องห้ามดังต่อไปนี้ในสัมภาระหรือพกพา ที่ต้องสำแดงหรือไม่? ",
              }
            ]
          },
          {
            margin: [-10, 0, -20, 0],
            text: [
              {
                style: "en",
                text: "Do you have any of the following substances in your possession or in baggage to declare? ",
                fontSize: 9,
                bold: false
              },
              {
                style: "th",
                text: "(ทำเครื่องหมาย Mark √)",
              },
            ]
          },
          {
            margin: [-20, 0, -40, 0],
            table: {
              widths: [30, 170, 200, 30, 30],
              body: [[{
                text: "สาร/ยาหรือสิ่งเสพติดต้องห้าม",
                style: "th",
                colSpan: 2,
                alignment: "center",
                bold: true,
                margin: [0, 5, 0, 0]
              }, "", {
                text: "Prohibited drugs / substances/ Medicine",
                style: "en",
                bold: false,
                alignment: "center",
                margin: [0, 5, 0, 0]
              }, {
                alignment: "center",
                text: [
                  {
                    style: "th",
                    text: "มี\n",
                    bold: false
                  },
                  {
                    style: "en",
                    text: "Yes",
                  },
                ]
              }, {
                alignment: "center",
                text: [
                  {
                    style: "th",
                    text: "ไม่มี\n",
                    bold: false
                  },
                  {
                    style: "en",
                    text: "No"
                  },
                ]
              }]
                , [
                {
                  style: 'th',
                  text: "1",
                  alignment: 'center'
                },
                {
                  style: 'th',
                  text: "กัญชา, กัญชง กระท่อม ",
                  margin: [0, -1, 0, 0]
                },
                {
                  style: 'en',
                  text: "Marijuana (Cannabis, Hemp) Kratom, ",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_1 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_1 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ]
                , [
                {
                  style: 'th',
                  text: "2",
                  alignment: 'center'
                },
                {
                  style: 'th',
                  text: "โคเคน ฝิ่น เฮโรอีน",
                  margin: [0, -1, 0, 0]
                },
                {
                  style: 'en',
                  text: "Cocaine, Opiates, Heroine, ",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_2 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_2 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ]
                , [
                {
                  style: 'th',
                  text: "3",
                  alignment: 'center'
                },
                {
                  style: 'th',
                  text: "มอร์ฟีน ยาบ้า ",
                  margin: [0, -1, 0, 0]
                },
                {
                  style: 'en',
                  text: "Morphine, Amphetamine, ",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_3 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_3 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ]
                , [
                {
                  style: 'th',
                  text: "4",
                  alignment: 'center'
                },
                {
                  style: 'th',
                  text: "ยาอี ยาไอซ์",
                  margin: [0, -1, 0, 0]
                },
                {
                  style: 'en',
                  text: "Ecstasy, Methylenedioxyamphetamine ",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_4 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_4 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ]
                , [
                {
                  style: 'th',
                  text: "5",
                  alignment: 'center',
                  margin: [0, 3, 0, 0]
                },
                {
                  style: 'th',
                  text: "ยาที่มีส่วนผสมของกัญชา ฝิ่น",
                  margin: [0, -1, 0, 0]
                },
                {
                  style: 'en',
                  text: "Medicine with marijuana/opiates as an ingredient",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_5 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_5 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ], [
                {
                  text: [
                    {
                      style: "th",
                      text: "** หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับสิ่งที่พกมาด้วย เช่น ยารักษาโรคหรืออาหารเสริม กรุณาสำแดงและสอบถามเจ้าหน้าที่\n",
                      bold: false,
                      fontSize: 14
                    },
                    {
                      style: "en",
                      text: "\t\tIf you have any medicines or food supplements on you and in doubts, please declare and contact check-in staff.",
                      fontSize: 9,
                      bold: false
                    },
                  ],
                  colSpan: 5
                }, "", "", "", ""
              ]
              ]
            }
          },
          {
            margin: [-20, 10, -20, 0],
            text: [
              {
                style: "th",
                text: "2) ท่านได้นำของเหลวหรือเครื่องดื่มดังต่อไปนี้ติดในสัมภาระหรือพกพาที่ต้องสำแดงหรือไม่ ",
              }
            ]
          },
          {
            margin: [-10, 0, -20, 0],
            text: [
              {
                style: "en",
                text: "Do you have any of the following alcohol beverages on you or in baggage to declare? ",
                fontSize: 9,
                bold: false
              },
              {
                style: "th",
                text: "(ทำเครื่องหมาย Mark √)",
              },
            ]
          },
          {
            margin: [-20, 0, -40, 0],
            table: {
              widths: [30, 170, 200, 30, 30],
              body: [[{
                text: "เครื่องดื่ม/ยาที่มีส่วนผสมแอลกอฮอล์ ",
                style: "th",
                colSpan: 2,
                alignment: "center",
                bold: true,
                margin: [0, 5, 0, 0]
              }, "", {
                text: "Prohibited Alcohol Mixed/Based Beverages/medicine",
                style: "en",
                bold: false,
                alignment: "center",
                margin: [0, 5, 0, 0]
              }, {
                alignment: "center",
                text: [
                  {
                    style: "th",
                    text: "มี\n",
                    bold: false
                  },
                  {
                    style: "en",
                    text: "Yes",
                  },
                ]
              }, {
                alignment: "center",
                text: [
                  {
                    style: "th",
                    text: "ไม่มี\n",
                    bold: false
                  },
                  {
                    style: "en",
                    text: "No"
                  },
                ]
              }]
                , [
                {
                  style: 'th',
                  text: "1",
                  alignment: 'center'
                },
                {
                  style: 'th',
                  text: "วิสกี้, ไวน์, บรั่นดี, รัม ",
                  margin: [0, -1, 0, 0]
                },
                {
                  style: 'en',
                  text: "Whiskey, wine, brandy, rum, ",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_6 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_6 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ]
                , [
                {
                  style: 'th',
                  text: "2",
                  alignment: 'center'
                },
                {
                  style: 'th',
                  text: "สาโท, อุ, กะแช่",
                  margin: [0, -1, 0, 0]
                },
                {
                  style: 'en',
                  text: "Malt, booze, liquor",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_7 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_7 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ]
                , [
                {
                  style: 'th',
                  text: "3",
                  alignment: 'center'
                },
                {
                  style: 'th',
                  text: "เบียร์, เบียร์ 0% แอลกอฮอล์, สาเก ",
                  margin: [0, -1, 0, 0]
                },
                {
                  style: 'en',
                  text: "Beers, 0% alcohol beer, sake ",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_8 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_8 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ]
                , [
                {
                  style: 'th',
                  text: "4",
                  alignment: 'center'
                },
                {
                  style: 'th',
                  text: "ไวน์คูลเลอร์, เครื่องดื่มหมักยีสต์ทุกประเภท",
                  margin: [0, -1, 0, 0],
                },
                {
                  style: 'en',
                  text: "Wine Cooler, any alcohol content beverages",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_9 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_9 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ]
                , [
                {
                  style: 'th',
                  text: "5",
                  alignment: 'center',
                  margin: [0, 3, 0, 0]
                },
                {
                  style: 'th',
                  text: "ยาแก้ไอ, ยาแก้ท้องอืด",
                  margin: [0, -1, 0, 0]
                },
                {
                  style: 'en',
                  text: "Cough medicine. Carminative mixture",
                  bold: false,
                  margin: [0, 1, 0, 0]
                },
                {
                  text: resdata.data[0].maf_declare_10 ? "√" : "",
                  style: "th",
                  alignment: 'center'
                }
                , {
                  text: resdata.data[0].maf_declare_10 ? "" : "√",
                  style: "th",
                  alignment: 'center'
                }
              ], [
                {
                  text: [
                    {
                      style: "th",
                      text: "** หากท่านมีคำถามหรือข้อสงสัยเกี่ยวกับสิ่งที่พกมาด้วย เช่น ยารักษาโรคหรืออาหารเสริม กรุณาสำแดงและสอบถามเจ้าหน้าที่\n",
                      bold: false,
                      fontSize: 14
                    },
                    {
                      style: "en",
                      text: "\t\tIf you have any medicines or food supplements on you and in doubts, please declare and contact check-in staff.",
                      fontSize: 9,
                      bold: false
                    },
                  ],
                  colSpan: 5
                }, "", "", "", ""
              ]
              ]
            }
          },
          "\n",
          {
            text: [
              {
                style: 'th',
                text: "3) รายการที่สำแดง (ถ้ามี) "
              },
              {
                style: 'en',
                text: "Declared items (if any)",
                bold: false
              }
            ]
          },
          {
            columns: [
              { width: "*", text: "" },
              {
                width: "auto",
                table: {
                  widths: [180, 20, 200],
                  body: drug_arr,
                },
              },
              { width: "*", text: "" },
            ],
          },
          "\n",

          {
            margin: [-20, 0, -40, 0],
            pageBreak: 'before',
            table: {
              widths: [365, 120],
              body:
                [
                  [
                    {
                      colSpan: 2,
                      text: [
                        {
                          text: "ข้าพเจ้ายินดีปฏิบัติตามนโยบายของบริษัท และขอยืนยันว่าข้อมูลที่สำแดงตามแบบสอบถามข้างบนเป็นจริงทุกประการ\n",
                          style: 'th'
                        },
                        {
                          text: "I acknowledge the Company’s Drugs and Alcohol Policy and hereby declare and confirm all answers are correct and true.",
                          style: 'en',
                          bold: false,
                          fontSize: 9
                        }
                      ]
                    }
                    , ""],
                  [
                    {
                      text: "ชื่อผู้โดยสาร Passenger Name:",
                      border: [true, true, true, false],
                    },
                    {
                      text: "วันที่ Date:",
                      border: [true, true, true, false],
                    }
                  ],
                  [
                    {
                      image: "signatureImage",
                      width: 80,
                      height: 20,
                      alignment: "center",
                      border: [true, false, true, false],
                    },
                    {
                      alignment: "center",
                      text: Nurseform.checkdatenull(resdata.data[0].maf_pass_sign_date),
                      border: [true, false, true, false],
                    }
                  ],
                  [
                    {
                      text: resdata.data[0].passenger.user.u_firstname + " " + resdata.data[0].passenger.user.u_lastname,
                      alignment: "center",
                      border: [true, false, true, true],
                    },
                    {
                      text: "",
                      border: [true, false, true, true],
                    }
                  ],
                  [
                    {
                      text: "ชื่อพยาบาลผู้ตรวจสอบ Nurse Name:",
                      border: [true, true, true, false],
                    },
                    {
                      text: "วันที่ Date:",
                      border: [true, true, true, false],
                    }
                  ],
                  [
                    {
                      image: "signaturenurseImage",
                      width: 80,
                      height: 20,
                      alignment: "center",
                      border: [true, false, true, false],
                    },
                    {
                      alignment: "center",
                      text: Nurseform.checkdatenull(resdata.data[0].maf_nurse_sign_date),
                      border: [true, false, true, false],
                    }
                  ],
                  [
                    {
                      text: resdata.data[0].maf_nurse_sign_name,
                      alignment: "center",
                      border: [true, false, true, true],
                    },
                    {
                      text: "",
                      border: [true, false, true, true],
                    }
                  ],
                ]
            }
          },

        ],
        footer: function (currentPage, pageCount) {
          var footer = [
            {
              text:
                "Alcohol and Urine Controlled Drugs Test Consent Form\nPage" +
                currentPage.toString() +
                " of " +
                pageCount,
              fontSize: 8,
              font: "Roboto",
              alignment: "center",
              color: "#C2C2C2",
            },
            {
              text: "INTERNAL",
              font: "Roboto",
              color: "red",
              fontSize: 12,
              margin: [15, 0, 0, 0],
            },
          ];

          return footer;
        },
        styles: {
          th: {
            fontSize: 15,
            lineHeight: 0.8,
          },
          en: {
            fontSize: 10,
            bold: true,
            font: "Roboto",
          },
        },
        defaultStyle: {
          font: "THSarabunNew",
        },
      };

      if (type == 1) {
        pdfMake.createPdf(docDefinitionyComplianceDeclarationForm).open({});
      } else if (type == 2) {
        pdfMake
          .createPdf(docDefinitionyComplianceDeclarationForm)
          .download(resdata.data[0].passenger.user.u_firstname + " " + resdata.data[0].passenger.user.u_lastname + "_" + PassId + "_Alcohol and drugs.pdf");
      }
      else if (type == 3) {
        const pdfDocGenerator = pdfMake.createPdf(docDefinitionyComplianceDeclarationForm);
        const wait = pdfData => new Promise(resolve => {
          pdfData.getBlob(blob => {
            resolve(blob);
          });
        });
        return await wait(pdfDocGenerator);
      }
    }

  },
  async PrintTestRecordForm(PassId, type) {
    var customerlogo = await LogoService.GetLogoBaseurl64(4);
    
    //Signature
    var qp = {};
    qp.p_id = PassId;
    qp.$eager =
      "[passenger,passenger.[user,destairport,departairport,company]]";

    var resdataHealth = await feathersClientUOA
      .service("mubadala-health-form-2")
      .find({ query: qp });
    if (resdataHealth.total > 0) {
      var dataHealth = resdataHealth.data[0];
      var signImageHealthPass = dataHealth.mhf_pass_singnature;
      //Signature
      var qp = {};
      qp.p_id = PassId;
      qp.$eager =
        "[passenger,passenger.[user,destairport,departairport,baggage,company]]";
      var resdata = await feathersClientUOA
        .service("mubadala-test-record-form")
        .find({ query: qp });
      if (resdata.total > 0) {
        let companyName = "";
        if (resdata.data[0].passenger.company != null) {
          companyName = "";
        }
        var signImageNurse = resdata.data[0].trf_nurse_singature;
        var pdfMake = require("../../public/js/pdfmake");
        if (pdfMake.vfs == undefined) {
          var pdfFonts = require("../../public/js/vfs_fonts");
          pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }
        pdfMake.fonts = {
          THSarabunNew: {
            normal: "THSarabunNew.ttf",
            bold: "THSarabunNew-Bold.ttf",
            italics: "THSarabunNew-Italic.ttf",
            bolditalics: "THSarabunNew-BoldItalic.ttf",
          },
          Roboto: {
            normal: "Roboto-Regular.ttf",
            bold: "Roboto-Medium.ttf",
            italics: "Roboto-Italic.ttf",
            bolditalics: "Roboto-MediumItalic.ttf",
          },
          Fontello: {
            normal: "fontello.ttf",
            bold: "fontello.ttf",
            italics: "fontello.ttf",
            bolditalics: "fontello.ttf",
          },
        };
        var docDefinitionyComplianceDeclarationForm = {
          pageMargins: [60, 70, 60, 40],
          images: {
            signatureImage: Nurseform.checkimgnull(signImageHealthPass),
            signaturenurseImage: Nurseform.checkimgnull(signImageNurse)
          },
          
          content: [
            {
              style:"en",
              text: "Test Record Form",
              bold: true,
              fontSize: 12,
              alignment: 'center'
            },
            "\n\n",
            {
              table: {
                widths: [317, 50, 50, 50],
                body: [
                  [
                    {
                      text: "Health Parameters",
                      bold: true,
                      alignment: 'center'
                    }, {
                      text: "1st  Record",
                      bold: true,
                      alignment: 'center'
                    }, {
                      text: "2nd Record",
                      bold: true,
                      alignment: 'center'
                    }, {
                      text: "3rd Record",
                      bold: true,
                      alignment: 'center'
                    }
                  ],
                  [
                    {
                      style: "en",
                      margin: [20, 5, 0, 0],
                      text: "1.	Temperature (Celsius °C)\n\n",
                      bold: true,
                    },
                    {
                      style: "en",
                      margin: [0, 5, 0, 0],
                      alignment:'center',
                      text: resdata.data[0].trf_temperature1,
                    },
                    {
                      style: "en",
                      text: "",
                      fillColor:"#7f7f7f"
                    },
                    {
                      style: "en",
                      text: "",
                      fillColor:"#7f7f7f"
                    }
                  ],
                  [
                    {
                      style: "en",
                      margin: [20, 5, 0, 0],
                      text: "2.	Blood Pressure (BP)\n\n",
                      bold: true,
                    },
                    {
                      style: "en",
                      margin: [0, 5, 0, 0],
                      alignment:'center',
                      text: (resdata.data[0].trf_blood_pressure1 ==null)?"":resdata.data[0].trf_blood_pressure1,
                    },
                    {
                      style: "en",
                      margin: [0, 5, 0, 0],
                      alignment:'center',
                      text: (resdata.data[0].trf_blood_pressure2 ==null)?"":resdata.data[0].trf_blood_pressure2,
                    },
                    {
                      style: "en",
                      margin: [0, 5, 0, 0],
                      alignment:'center',
                      text: (resdata.data[0].trf_blood_pressure3 ==null)?"":resdata.data[0].trf_blood_pressure3,
                    }
                  ],
                  [
                    {
                      style: "en",
                      margin: [20, 5, 0, 0],
                      text: "3.	% Blood Alcohol Concentration (%BAC)\n\n",
                      bold: true,
                    },
                    {
                      style: "en",
                      margin: [0, 5, 0, 0],
                      alignment:'center',
                      text:  (resdata.data[0].trf_blood_alcohol1 ==null)?"":resdata.data[0].trf_blood_alcohol1,
                    },
                    {
                      style: "en",
                      margin: [0, 5, 0, 0],
                      alignment:'center',
                      text:  (resdata.data[0].trf_blood_alcohol2 ==null)?"":resdata.data[0].trf_blood_alcohol2,
                    },
                    {
                      style: "en",
                      text: "",
                      fillColor:"#7f7f7f",
                      alignment:'center',
                    }
                  ]
                ]
              }
            },
            "\n\n",
            {
              table: {
                widths: [345, 140],
                body:
                  [
                    [
                      {
                        text: "ชื่อผู้โดยสาร Passenger Name:",
                        border: [true, true, true, false],
                      },
                      {
                        text: "วันที่ Date:",
                        border: [true, true, true, false],
                      }
                    ],
                    [
                      {
                        image: "signatureImage",
                        width: 80,
                        height: 20,
                        alignment: "center",
                        border: [true, false, true, false],
                      },
                      {
                        alignment: "center",
                        text: Nurseform.checkdatenull(dataHealth.mhf_pass_sign_date),
                        border: [true, false, true, false],
                      }
                    ],
                    [
                      {
                        text: resdata.data[0].passenger.user.u_firstname + " " + resdata.data[0].passenger.user.u_lastname,
                        alignment: "center",
                        border: [true, false, true, true],
                      },
                      {
                        text: "",
                        border: [true, false, true, true],
                      }
                    ],
                    [
                      {
                        text: "ชื่อพยาบาลผู้ตรวจสอบ Nurse Name:",
                        border: [true, true, true, false],
                      },
                      {
                        text: "วันที่ Date:",
                        border: [true, true, true, false],
                      }
                    ],
                    [
                      {
                        image: "signaturenurseImage",
                        width: 80,
                        height: 20,
                        alignment: "center",
                        border: [true, false, true, false],
                      },
                      {
                        alignment: "center",
                        text: Nurseform.checkdatenull(resdata.data[0].trf_mau_nurse_sign_date),
                        border: [true, false, true, false],
                      }
                    ],
                    [
                      {
                        text: resdata.data[0].trf_nurse_sign_name,
                        alignment: "center",
                        border: [true, false, true, true],
                      },
                      {
                        text: "",
                        border: [true, false, true, true],
                      }
                    ],
                  ]
              }
            },

          ],
          footer: function (currentPage, pageCount) {
            var footer = [
              {
                text: "INTERNAL",
                font: "Roboto",
                color: "red",
                fontSize: 12,
                margin: [15, 0, 0, 0],
              },
            ];

            return footer;
          },
          styles: {
            th: {
              fontSize: 15,
              lineHeight: 0.8,
            },
            en: {
              fontSize: 10,
              bold: true,
              font: "Roboto",
            },
          },
          defaultStyle: {
            font: "THSarabunNew",
          },
        };

        if (type == 1) {
          pdfMake.createPdf(docDefinitionyComplianceDeclarationForm).open({});
        } else if (type == 2) {
          pdfMake
            .createPdf(docDefinitionyComplianceDeclarationForm)
            .download(resdata.data[0].passenger.user.u_firstname + " " + resdata.data[0].passenger.user.u_lastname + "_" + PassId + "_Alcohol and drugs.pdf");
        }
        else if (type == 3) {
          const pdfDocGenerator = pdfMake.createPdf(docDefinitionyComplianceDeclarationForm);
          const wait = pdfData => new Promise(resolve => {
            pdfData.getBlob(blob => {
              resolve(blob);
            });
          });
          return await wait(pdfDocGenerator);
        }
      }
    }
  },
  istruebool: (choice) => {
    if (choice) return "√";
    else return "";
  },
  isfalsebool: (choice) => {
    if (!choice) return "√";
    else return "";
  },
  checkbox: (id, idchecked) => {
    if (id == idchecked) {
      var result = {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAAdklEQVQ4y2NgGLTAg+Exw3888DFQBQp4hFc5CD5C1QASwgcw5KmoQYc0DVEMfxjqiNcAUv6foYZYDQjleDRoYlWOU0Mdw2+GECzKcWpoAZK/GUIxlONxUjNYC7pyvJ5uBrNrSIm4JgzltE0aOORJTt4kZ6BBBAADNZmOfmKY6QAAAABJRU5ErkJggg==",
        width: 13,
        alignment: "right",
        border: [false, false, false, false],
      };
      return result;
    } else {
      var result = {
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzA2MEU3NzY5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzA2MEU3Nzc5RjVDMTFFQzlCMDU5REY3NTlERTQ4QkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDMDYwRTc3NDlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDMDYwRTc3NTlGNUMxMUVDOUIwNTlERjc1OURFNDhCQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PreteusAAABpSURBVHjaYvz//z8DLQETA40BzS1gAAURDAOBBxA/BgmTiUF6PVDMRLPgEQWGw/AjZDMZkSOZkZHxP9RXjOSEBjb9Qz+SRy0YtWDUglELiAAsaHxQeS4LKxXJBI/pWuEwjlb6hABAgAEAF698FDGkuJwAAAAASUVORK5CYII=",
        width: 13,
        alignment: "right",
        border: [false, false, false, false],
      };
      return result;
    }
  },
  covidQuestiontext: (result, Comment) => {
    if (result) {
      var text = {
        background: "#ffa8a8",
        style: "th",
        text: "Yes " + Comment,
        bold: true,
        margin: [20, 0, 0, 0]
      };
      return text;
    } else {
      var text = {
        style: "th",
        text: "No " + Comment,
        bold: true,
        margin: [20, 0, 0, 0]
      };
      return text;
    }
  },
  covidYes: (result) => {
    if (result) {
      var img = {
        image:
          "data:image/png;base64,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",
        height: 24,
        width: 48,
        margin: [0, 1, 0, 0]
      };
      return img;
    }
    else {
      var img = {
        image:
          "data:image/png;base64,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",
        height: 24,
        width: 48,
        margin: [0, 1, 0, 0]
      };
      return img;
    }
  },
  covidNo: (result) => {
    if (!result) {
      var img = {
        image:
          "data:image/png;base64,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",
        height: 24,
        width: 48,
        margin: [0, 1, 0, 0]
      };
      //   console.log(img)
      return img;
    }
    else {
      var img = {
        image:
          "data:image/png;base64,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",
        height: 24,
        width: 48,
        margin: [0, 1, 0, 0]
      };
      return img;
    }
  },
  checkimgnull: (img) => {
    if (img == null) {
      var whiteimg = 'data:image/png;base64,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'
      return whiteimg
    }
    else {
      return img
    }
  },
  checkdatenull: (date) => {
    if (date == null) {
      return ""
    }
    else {
      // return format(
      //   addHours(new Date(date), -7),
      //   "dd MMM yyyy"
      // )
      return format(new Date(date),"dd MMM yyyy")
    }
  },
  ispassbool(choice) {
    if (choice == "Passed") return "√";
    else return "";
  },
  isnotpassbool(choice) {
    if (choice == "Failed") return "√";
    else return "";
  },
}
